import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const devConfig = {
  apiKey: "AIzaSyBFr2JdDcOrJLD-Dnn-eGckb3IN77befKk",
  authDomain: "cff-raider-depot-dev.firebaseapp.com",
  projectId: "cff-raider-depot-dev",
  storageBucket: "cff-raider-depot-dev.firebasestorage.app",
  messagingSenderId: "301580893720",
  appId: "1:301580893720:web:0cbd9945b848baca108d6d",
  measurementId: "G-32V0DLSV7L",
};

const prodConfig = {
  apiKey: "AIzaSyAtv2Ax3h3xcy0ovO5hdcNfatEYq7GK0CM",
  authDomain: "cff-raider-depot-prod.firebaseapp.com",
  projectId: "cff-raider-depot-prod",
  storageBucket: "cff-raider-depot-prod.firebasestorage.app",
  messagingSenderId: "322280835515",
  appId: "1:322280835515:web:661b3175901a620aad1c9e",
};

const firebaseConfig = process.env.REACT_APP_ENV === "production" ? prodConfig : devConfig;

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
export { app, auth, db };
